/* eslint-disable no-throw-literal */
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.scss";
import CustomDatePicker from "../shared/datePicker";
import NotificationPopup from "../shared/notificationPopup";
import { PoweredBy } from "../shared/PoweredBy";
import SelectDateTimePopup from "../shared/selectDateTimePopup";
import { headerDisplaying, isLoadChanger } from "../store/mainSlice";
import {
  activeMultipleEntryPassesDetailsSelector,
  hasActiveMultipleEntryPassSelector,
} from "../store/multipleEntryPassSlice";
import { isPartnerClalit } from "../store/partnerStore";

function getDatesForNextMonth() {
  const dates = [];
  const today = moment();
  for (let i = 0; i < 3; i++) {
    const nextDate = today.clone().add(i, "days");
    dates.push(nextDate.format("DD/MM/YYYY"));
  }
  return dates;
}

function getLargerTimes(input, timeArray) {
  return timeArray.filter((time) => parseInt(time) > input);
}
const SelectDateTime = () => {
  const { t } = useTranslation();
  const [openNotificationPopup, setOpenNotificationPopup] = useState(false);
  const [selectedDate, setSelectedDate] = useState({
    date: moment().format("DD/MM/YYYY"),
  });
  const dispatch = useDispatch();
  const [selectedHours, setSelectedHours] = useState({
    hour: moment().format("HH"),
  });
  const navigate = useNavigate();
  const location = useLocation();
  const isClalit = useSelector(isPartnerClalit);
  const [selectedMinutes, setSelectedMinutes] = useState({ minute: "00" });
  const [values, setValues] = useState({ dates: [], hours: [], minutes: [] });
  const [isOpen, setIsOpen] = useState(false);
  const userParams = useSelector((state) => state.userSlice.userData);
  const isHaveCard = useSelector((state) => state.userSlice.isHaveCreditCard);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
  const cityAndClubs = useSelector((state) => state.appParamSlice.allAppParams);

  const hasActiveMultipleEntryPass = useSelector(hasActiveMultipleEntryPassSelector);
  const multipleEntryPassDetails = useSelector(activeMultipleEntryPassesDetailsSelector);

  useEffect(() => {
    dispatch(headerDisplaying(false));
    return () => {
      dispatch(headerDisplaying(true));
    };
  }, []);

  useEffect(() => {
    const dates = location.state.orderTimeRange || getDatesForNextMonth();
    const hours = Array.from({ length: 23 }, (v, i) => (i + 1 > 9 ? "" : "0") + (i + 1));
    hours.unshift("00");
    let minutes = ["00", "15", "30", "45"];
    if (moment().format("DD/MM/YYYY") === selectedDate.date) {
      if (Number(moment().format("mm")) > 44) {
        hours.splice(0, Number(moment().format("HH")) + 1);
      } else {
        hours.splice(0, Number(moment().format("HH")));
        minutes = getLargerTimes(Number(moment().format("mm")), minutes);
      }
      setSelectedHours({ hour: hours[0] });
      setSelectedMinutes({ minute: minutes[0] });
    }
    setValues({
      dates: { date: dates },
      hours: { hour: hours },
      minutes: { minute: minutes },
    });
  }, [selectedDate]);

  const redirectWithCondition = async () => {
    dispatch(isLoadChanger(true));
    try {
      const selectedClub = cityAndClubs.ClubList.find((el) => el.RecordID === location.state.clubId);
      if (isHaveCard || (isClalit && hasActiveMultipleEntryPass && multipleEntryPassDetails.NumberOfEntries < 4)) {
        navigate("/summary", {
          state: {
            date: selectedDate.date,
            hours: selectedHours.hour,
            minutes: selectedMinutes.minute,
            clubId: location.state.clubId,
            clubName: location.state?.clubName,
            type: "invite",
          },
        });
      } else {
        navigate("/addCard", {
          state: {
            date: selectedDate.date,
            hours: selectedHours.hour,
            minutes: selectedMinutes.minute,
            clubId: location.state.clubId,
            clubName: location.state?.clubName,
            route: "orderConfirmation",
          },
        });
      }
      dispatch(isLoadChanger(false));
    } catch (err) {
      dispatch(isLoadChanger(false));
      setOpenNotificationPopup(true);
    }
  };

  const onSelectedHoursChanged = (value) => {
    setSelectedHours(value);
    const minOptions = ["00", "15", "30", "45"];
    try {
      if (Number(value.hour) > Number(moment().format("HH"))) {
        setValues({ ...values, minutes: { minute: minOptions } });
      } else {
        const minute = getLargerTimes(Number(moment().format("mm")), minOptions);
        setValues({ ...values, minutes: { minute: minute } });
      }
    } catch (error) {
      const minute = getLargerTimes(Number(moment().format("mm")), minOptions);
      setValues({ ...values, minutes: { minute: minute } });
    }
  };

  return (
    <div className="main-page-container flex-rules-for-date-time-container">
      <div
        className="select-date-time-content-container"
        style={{
          display: "flex",
          height: "100%",
          justifyContent: "space-evenly",
        }}
      >
        <div>
          <p className="select-date-time-content-text">{t("SELECT_DATE")}</p>
          <CustomDatePicker values={values.dates} value={selectedDate} setValue={setSelectedDate} />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <p className="select-date-time-content-text">{t("SELECT_TIME")}</p>
          <div className="select-date-time-content-time-container">
            <CustomDatePicker
              values={values.hours}
              value={selectedHours}
              setValue={onSelectedHoursChanged}
              isTime={true}
            />
            <Typography color="var(--darkblue)" fontWeight={400} fontSize={"36px"}>
              :
            </Typography>
            <CustomDatePicker
              values={values.minutes}
              value={selectedMinutes}
              setValue={setSelectedMinutes}
              isTime={true}
            />
          </div>
        </div>
      </div>
      <div className="select-date-time-btn-block">
        <Button
          style={{ height: "58px" }}
          variant="contained"
          className="blue-btn select-date-time-btn-props"
          onClick={() => setIsOpen(true)}
        >
          <div className="select-date-time-btn-text-position">
            <span style={{ fontSize: "18px" }}>{t("CREATE_ORDER")}</span>
          </div>
        </Button>

        {isClalit && (
          <div>
            <PoweredBy />
          </div>
        )}
      </div>
      <SelectDateTimePopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        headerText={t("ORDER_CONFIRMATION")}
        bodyText={[
          `${t("BOOK_WORKOUT_QUESTION")} ${location.state?.clubName} `,
          `${selectedHours.hour}:${selectedMinutes.minute} ${t("AT_TIME")}  ${selectedDate.date}, ${t("ON_DATE")}`,
        ]}
        clubName={location.state?.clubName}
        oneLineTitle={!isClalit}
        selectedHours={selectedHours.hour}
        selectedMinutes={selectedMinutes.minute}
        selectedDays={selectedDate.date}
        onConfirm={() => redirectWithCondition()}
        confirmBtnText={t("CONFIRMATION_BOOK")}
        cancelBtnText={t("CONFIRMATION_CANCEL")}
      />
      <NotificationPopup
        isOpen={openNotificationPopup}
        setIsOpen={setOpenNotificationPopup}
        bodyTopText={t("FUTURE_ACTIVITY_MESSAGE_TITLE")}
        bodyText={t("FUTURE_ACTIVITY_MESSAGE_TEXT")}
        btnText={t("CLOSE")}
      />
    </div>
  );
};

export default SelectDateTime;
